module.exports = __webpack_public_path__ + "static/media/tipml.7ac629f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tipml.png
// module id = 446
// module chunks = 0